<template>
    <div class="fixed inset-0 bg-opacity-60 bg-black flex justify-center items-center">
        <!-- Modal Header -->

        <!-- Modal Body -->
        <div
            id="modal"
            class="bg-white rounded-[10px] overflow-x-auto flex flex-col justify-between w-2/6 h-3/5"
        >
            <!-- Modal Header -->

            <!-- Modal Body -->
            <div class="flex flex-col justify-center items-center h-full w-[90%] mx-auto">
                <img src="../../assets/done.gif" alt="" class="w-[175px] h-[175px] mb-8" />
                <p class="text-[30px] font-bold">Thank You</p>
                <p class="text-[14px] text-black text-opacity-80 text-center mb-8">
                    Your campaign has been submitted successfully, and is being reviewed. Expect a
                    response soon.
                </p>
                <p class="text-[12px] text-[#A6A6A6] text-opacity-100">
                    Please note that it may take up to 48 hours for content review and clearance.
                </p>
            </div>
            <!-- Modal Footer -->
        </div>
        <!-- Modal Footer -->
    </div>
</template>

<script>
export default {
    name: "Modal",
};
</script>

<style></style>
